import React from "react";

const Contacto: React.FC = () => {
  return (
    <div className="container mx-auto p-4">
            <h1 className="text-4xl font-bold text-center my-8">Contáctanos</h1>
           {" "}
      <div className="text-center my-4">
               {" "}
        <p>
          Si tienes alguna pregunta o deseas más información sobre nuestros
          tours, no dudes en contactarnos.
        </p>
             {" "}
      </div>
           {" "}
      <div className="flex justify-center space-x-4 my-8">
               {" "}
        <a
          href="tel:+591..."
          className="bg-blue-500 text-white p-2 rounded hover:bg-blue-700"
        >
          Llamar
        </a>
               {" "}
        <a
          href="mailto:..."
          className="bg-green-500 text-white p-2 rounded hover:bg-green-700"
        >
          Enviar Correo
        </a>
                https://wa.me/591...      {" "}
      </div>
         {" "}
    </div>
  );
};

export default Contacto;
